export const state = {
  loader: false,
  resetPasswordEmail: "",
  emails:[]
}
